function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m16.5 0c-9.11625 0-16.5 7.38375-16.5 16.5 0 9.1163 7.38375 16.5 16.5 16.5 9.1163 0 16.5-7.3837 16.5-16.5 0-9.11625-7.3837-16.5-16.5-16.5zm-6.1875 7.3425 6.1875 6.1875 6.1875-6.1875 2.97 2.97-6.1875 6.1875 6.1875 6.1875-2.97 2.97-6.1875-6.1875-6.1875 6.1875-2.97-2.97 6.1875-6.1875-6.1875-6.1875z",
  fill: "#f1f5fa"
});

var SvgNo = function SvgNo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 33,
    viewBox: "0 0 33 33",
    width: 33,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no.64128179.svg";
export { ForwardRef as ReactComponent };